import { IGroupsState } from "v3/data/store/group/types";

export const groupsFilterInitialState = {
  searchStore: '',
  page: 0,
  rowsPerPage: 20,
};

export const groupsInitialState: IGroupsState = {
  group: {
    id: '',
    name: '',
  },
  list: {
    items: [],
    count: 0,
  },
  filter: {
    name: '',
    page: 0,
    rowsPerPage: 20,
  },
};
